module.exports = __webpack_public_path__ + "static/img/015.0d7f10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/015.png
// module id = OSu0
// module chunks = 0